import { analyticsConfig } from "@/lib/analytics/config";
import { UserEventLogger, UserLogin } from "@/lib/analytics/event-logger";
import { AnalyticsEvent, AnalyticsEventPayload } from "@/lib/analytics/events";
import mixpanel from "@/utils/mixpanel";
import webengage from "@/webengage";

type AnalyticsService = "mixpanel" | "webengage" | "event-logger";

interface TrackOptions {
  services?: AnalyticsService[];
}

export const trackEvent = <E extends AnalyticsEvent>(
  event: E,
  data?: AnalyticsEventPayload<E>,
  options?: TrackOptions
) => {
  const services =
    options?.services ??
    (Object.keys(analyticsConfig).filter(
      (key) => analyticsConfig[key as AnalyticsService]
    ) as AnalyticsService[]);

  const _webengage = webengage();

  services.forEach((service) => {
    switch (service) {
      case "mixpanel":
        if (analyticsConfig.mixpanel) mixpanel.track(event, data);
        break;
      case "webengage":
        if (analyticsConfig.webengage) _webengage?.track(event, data);
        break;
      case "event-logger":
        if (analyticsConfig["event-logger"]) {
          UserEventLogger(event, data);
        }
        break;
    }
  });
};

export const loginEvent = (
  data: {
    name: string;
    phone: string;
    email?: string;
  },
  options?: TrackOptions
) => {
  const services =
    options?.services ??
    (Object.keys(analyticsConfig).filter(
      (key) => analyticsConfig[key as AnalyticsService]
    ) as AnalyticsService[]);

  const _webengage = webengage();

  services.forEach((service) => {
    switch (service) {
      case "mixpanel":
        if (analyticsConfig.mixpanel) {
          mixpanel.identify(data.phone);
          mixpanel.people.set({
            $email: data.email,
            $name: data.name,
            $phone: data.phone,
          });
        }
        break;
      case "webengage":
        if (analyticsConfig.webengage) {
          _webengage?.user.login(data.phone);
          _webengage?.user.setAttribute("we_name", data.name);
          _webengage?.user.setAttribute("we_email", data.email);
          _webengage?.user.setAttribute("we_phone", data.phone);
        }
        break;
      case "event-logger":
        if (analyticsConfig["event-logger"]) {
          UserLogin(data);
        }
        break;
    }
  });
};
